"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./styles"));

var _ContentImage = _interopRequireDefault(require("./components/ContentImage"));

var _DarkText = _interopRequireDefault(require("../DarkText"));

var _getDuration = _interopRequireDefault(require("./helper/getDuration"));

var topInfos = function topInfos(_ref) {
  var contentType = _ref.contentType,
      duration = _ref.duration;
  return _react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, _react.default.createElement(_DarkText.default, {
    className: s.contentInfoText,
    fontSize: 10,
    color: "iron",
    letterSpacing: "2"
  }, contentType), _react.default.createElement(_DarkText.default, {
    className: s.contentInfoSeperator,
    fontSize: 10,
    color: "iron",
    letterSpacing: "2"
  }, "\u2022"), _react.default.createElement(_DarkText.default, {
    className: s.contentInfoText,
    fontSize: 10,
    color: "iron",
    letterSpacing: "2"
  }, (0, _getDuration.default)(duration)));
};

function AssignAssetInfoCard(props) {
  var className = props.className,
      name = props.name,
      contentId = props.contentId,
      image = props.image,
      contentType = props.contentType,
      duration = props.duration;
  return _react.default.createElement("div", {
    key: contentId,
    className: (0, _classnames.default)(s.root(), className)
  }, _react.default.createElement(_ContentImage.default, {
    image: image,
    height: 32,
    width: 32
  }), _react.default.createElement("div", {
    style: {
      padding: '0 8px'
    }
  }, topInfos({
    contentType: contentType,
    duration: duration
  }), _react.default.createElement(_DarkText.default, {
    className: s.contentNameAssign,
    fontSize: 16,
    color: "copper"
  }, name)));
}

var _default = AssignAssetInfoCard;
exports.default = _default;